(function() {
  'use strict';

  // 数字滚动动画类
  class NumberCounter {
    constructor(element, options = {}) {
      this.element = element;
      this.duration = options.duration || 2000; // 动画时长，默认2秒
      this.delay = options.delay || 0; // 延迟开始时间
      this.easing = options.easing || 'easeOutCubic'; // 缓动函数
      
      // 提取原始文本和数字
      this.originalText = element.textContent.trim();
      this.numbers = this.extractNumbers(this.originalText);
      
      if (this.numbers.length === 0) {
        return; // 没有数字，不执行动画
      }
      
      this.startTime = null;
      this.isAnimating = false;
      this.init();
    }

    // 提取文本中的数字
    extractNumbers(text) {
      const regex = /(\d+(?:\.\d+)?)/g;
      const matches = [];
      let match;
      
      while ((match = regex.exec(text)) !== null) {
        const original = match[0];
        const value = parseFloat(original);
        // 检测是否有前导0（比如 "0574"）
        const hasLeadingZero = original.length > 1 && original[0] === '0' && !original.includes('.');
        
        matches.push({
          value: value,
          startIndex: match.index,
          endIndex: match.index + original.length,
          original: original,
          hasLeadingZero: hasLeadingZero
        });
      }
      return matches;
    }

    // 缓动函数
    easingFunctions = {
      linear: (t) => t,
      easeInQuad: (t) => t * t,
      easeOutQuad: (t) => t * (2 - t),
      easeInOutQuad: (t) => t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t,
      easeInCubic: (t) => t * t * t,
      easeOutCubic: (t) => --t * t * t + 1,
      easeInOutCubic: (t) => t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1
    };

    // 格式化数字（保持原始格式，如小数点位数）
    formatNumber(value, numInfo) {
      // 如果值为0，返回空字符串（不显示0）
      if (value <= 0) {
        return '';
      }
      
      const original = numInfo.original;
      
      // 处理小数
      if (original.includes('.')) {
        const decimals = original.split('.')[1].length;
        return value.toFixed(decimals);
      }
      
      // 如果是整数，直接返回数值，不保留原始格式的位数
      // 这样 1780 在动画到 178 时显示 "178" 而不是 "0178"
      const formattedValue = Math.floor(value).toString();
      return formattedValue;
    }

    // 更新文本
    updateText(progress) {
      let newText = this.originalText;
      
      // 从后往前替换，避免索引变化问题
      for (let i = this.numbers.length - 1; i >= 0; i--) {
        const num = this.numbers[i];
        const currentValue = num.value * progress;
        let formattedValue = this.formatNumber(currentValue, num);
        
        // 当formattedValue为0时，用空字符串替换，并去掉后面值中的千分位和百万分位逗号
        // 但只有当逗号前面没有数字时才去掉逗号
        if (formattedValue === '0' || formattedValue === '') {
          formattedValue = '';
          // 获取数字后面的文本
          let textAfter = newText.substring(num.endIndex);
          
          // 检查并去掉千分位和百万分位逗号（只有当逗号前面没有数字时）
          // 如果逗号紧跟在被替换的数字后面（即逗号前面没有数字），则去掉逗号
          if (textAfter.length > 0 && textAfter[0] === ',') {
            // 逗号紧跟在数字后面，去掉这个逗号
            textAfter = textAfter.substring(1);
          } else {
            // 检查是否有逗号，且逗号前面没有数字（即逗号前面是空字符串或其他非数字字符）
            // 这里我们只处理紧跟在数字后面的逗号，因为如果逗号前面有数字，说明是其他数字的千分位，不应该去掉
            textAfter = textAfter.replace(/^,/, ''); // 只去掉开头的逗号
          }
          
          newText = newText.substring(0, num.startIndex) + 
                    formattedValue + 
                    textAfter;
        } else {
          newText = newText.substring(0, num.startIndex) + 
                    formattedValue + 
                    newText.substring(num.endIndex);
        }
      }
      
      this.element.textContent = newText;
    }

    // 动画循环
    animate(timestamp) {
      if (!this.startTime) {
        this.startTime = timestamp;
      }
      
      const elapsed = timestamp - this.startTime;
      
      if (elapsed < this.delay) {
        requestAnimationFrame((ts) => this.animate(ts));
        return;
      }
      
      const adjustedElapsed = elapsed - this.delay;
      const progress = Math.min(1, adjustedElapsed / this.duration);
      
      const easedProgress = this.easingFunctions[this.easing](progress);
      this.updateText(easedProgress);
      
      if (progress < 1) {
        requestAnimationFrame((ts) => this.animate(ts));
      } else {
        // 确保最终值是准确的
        this.updateText(1);
        this.isAnimating = false;
      }
    }

    // 初始化
    init() {
      // 初始设置为0
      this.updateText(0);
      
      // 延迟后开始动画
      setTimeout(() => {
        this.isAnimating = true;
        requestAnimationFrame((ts) => this.animate(ts));
      }, this.delay);
    }

    // 重新开始动画
    restart() {
      this.startTime = null;
      this.isAnimating = false;
      this.updateText(0);
      setTimeout(() => {
        this.isAnimating = true;
        requestAnimationFrame((ts) => this.animate(ts));
      }, this.delay);
    }
  }

  // 初始化所有计数器
  function initCounters() {
    const counters = document.querySelectorAll('.of-featured-list-item-title');
    
    counters.forEach((element) => {
      // 检查是否已经初始化
      if (element.dataset.counterInitialized === 'true') {
        return;
      }
      
      // 检查是否有数字
      const hasNumber = /\d/.test(element.textContent);
      if (!hasNumber) {
        return;
      }
      
      // 获取配置
      const duration = parseInt(element.dataset.duration) || 2000;
      const delay = parseInt(element.dataset.delay) || 0;
      const easing = element.dataset.easing || 'easeOutCubic';
      
      // 创建计数器实例
      const counter = new NumberCounter(element, {
        duration: duration,
        delay: delay,
        easing: easing
      });
      
      // 标记为已初始化
      element.dataset.counterInitialized = 'true';
      element.counterInstance = counter;
    });
  }

  // 使用 Intersection Observer 实现进入视窗时才开始动画
  function initCountersWithObserver() {
    const counters = document.querySelectorAll('.of-featured-list-item-title');
    
    if (counters.length === 0) return;
    
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting && entry.target.dataset.counterInitialized !== 'true') {
          const element = entry.target;
          
          // 检查是否启用动画
          // data-show-animation 的值可以是 "true" 或 "false"（字符串）
          // 如果属性存在且值为 "true"，则启用动画
          // 如果属性不存在或值不是 "true"，则不启用动画
          const showAnimation = element.dataset.showAnimation === 'true';
          if (!showAnimation) {
            // 如果未启用动画，标记为已初始化但不执行动画，直接返回
            element.dataset.counterInitialized = 'true';
            return;
          }
          
          // 检查是否有数字
          const hasNumber = /\d/.test(element.textContent);
          if (!hasNumber) {
            return;
          }
          
          // 获取配置
          const duration = parseInt(element.dataset.duration) || 2000;
          const delay = parseInt(element.dataset.delay) || 0;
          const easing = element.dataset.easing || 'easeOutCubic';
          
          // 创建计数器实例
          const counter = new NumberCounter(element, {
            duration: duration,
            delay: delay,
            easing: easing
          });
          
          // 标记为已初始化
          element.dataset.counterInitialized = 'true';
          element.counterInstance = counter;
          
          // 停止观察
          observer.unobserve(element);
        }
      });
    }, {
      threshold: 0.1, // 当10%的元素可见时触发
      rootMargin: '0px'
    });
    
    counters.forEach((counter) => {
      observer.observe(counter);
    });
  }

  // DOM 加载完成后初始化
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      // 使用 Intersection Observer 实现进入视窗时才开始动画
      initCountersWithObserver();
    });
  } else {
    initCountersWithObserver();
  }

  // 监听动态内容加载
  if (typeof MutationObserver !== 'undefined') {
    const observer = new MutationObserver(() => {
      initCountersWithObserver();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  // 导出全局方法
  window.refreshFeaturedListCounters = initCountersWithObserver;
  
  // 动态控制单个元素的动画开关
  window.toggleFeaturedListAnimation = function(element, enable) {
    if (!element) return;
    
    // 设置 data-show-animation 属性
    if (enable) {
      element.setAttribute('data-show-animation', 'true');
    } else {
      element.setAttribute('data-show-animation', 'false');
      // 如果动画正在运行，停止它
      if (element.counterInstance) {
        element.counterInstance.destroy();
        element.counterInstance = null;
        element.dataset.counterInitialized = 'false';
        // 恢复原始文本
        if (element.counterInstance && element.counterInstance.originalText) {
          element.textContent = element.counterInstance.originalText;
        }
      }
    }
    
    // 重新初始化
    initCountersWithObserver();
  };
})();

